<template>
  <div
    :style="{
      width: `${size}px`,
      height: `${size}px`,
      'min-width': `${size}px`,
      'min-height': `${size}px`,
      '--border-width': `${borderWidth}px`
    }"
    class="profile-image-wrapper align-center justify-center rounded-circle"
    :class="{bordered}"
  >
    <div
      v-if="!user?.profile_picture_id"
      class="rounded-circle d-flex align-center justify-center"
      :style="{
        width: `${size}px`,
        'min-width': `${size}px`,
        height: `${size}px`,
        'min-height': `${size}px`,
      }"
    >
      <v-icon
        v-if="add"
        icon="add_a_photo"
        color="secondary"
        :size="40"
      />
      <div
        v-else
        class="text-uppercase initials"
        :style="{
          fontSize: `${parseFloat(size + '') / 2}px`,
        }"
      >
        {{ initials }}
      </div>
    </div>
    <v-img
      v-else
      :src="assetUrl(user?.profile_picture_id)"
      class="rounded-circle h-100 w-100 bg-white"
      cover
    />
  </div>
</template>
<script lang="ts">
import {assetUrl} from "@/plugins/file"

export default {
  name: 'ProfileImage',
  methods: {assetUrl},
  props: {
    user: {
      type: Object as any,
      default: null,
    },
    size: {
      type: [Number, String],
      default: 30,
    },
    add: Boolean,
    bordered: Boolean,
    borderWidth: {
      type: [Number, String],
      default: 2,
    },
  },
  computed: {
    initials() {
      return [
        this.user?.first_name,
        this.user?.last_name,
      ]
        .filter(Boolean)
        .map(n => n[0])
        .join('')
    },
    colorFromInitials() {
      const colors = [
        '#eebdbd',
        '#f1dbcb',
        '#eff1ce',
        '#c4e7be',
        '#b6e2e8',
        '#c2d2ee',
        '#c6c1ee',
        '#e3bde3',
      ]
      const charCodeSum = this.initials
        .split('')
        .reduce((acc, char) => acc + char.charCodeAt(0), 0)
      return colors[charCodeSum % colors.length]
    }
  },
}
</script>

<style lang="scss" scoped>
.profile-image-wrapper {
  flex-shrink: 0;
  display: flex;
  &.bordered {
    position: relative;
    border: var(--border-width) solid white;
  }

  .initials {
    font-weight: 600;
    opacity: .5;
  }

  .rounded-circle  {
    background-color: rgb(var(--v-theme-accent));
  }
}
</style>
